// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { searchWithinStyles } from "@insite/content-library/Widgets/ProductList/ProductListSearchWithin";
import { DivWrapper } from "@tps/XDL/constants";
import Search from "@tps/XDL/Icons/Search";
import { color } from "@tps/XDL/Utilities";
import { css } from "styled-components";

searchWithinStyles.wrapper = {
    css: css`
        padding: 9px 9px 0;
        background: ${color("common.background")};
        border: 1px solid ${color("common.border")};
        line-height: 1;
        ${DivWrapper}:not(:empty) {
            margin-top: 12px;
        }
    `,
};

searchWithinStyles.titleText = {
    size: 14,
};

searchWithinStyles.searchTextField = {
    iconProps: {
        src: Search,
        color: "common.ui5",
    },
    cssOverrides: {
        formInputWrapper: css`
            &&&& input {
                padding: 0 30px 0 9px;
            }
        `,
        formField: css`
            width: 100%;
            label {
                font-weight: bold;
            }
        `,
    },
};
